import { create } from 'zustand'
import { ActionBarStoreType, FileType } from './types/types'

export const useActionBarStore = create<ActionBarStoreType>()((set) => ({
    /** initial state */
    isPDFExportLoading: false,
    isWordExportLoading: false,
    isSupportingDocsLoading: false,
    pdfExportUrl: '',
    wordExportUrl: '',
    supportingDocsUrl: '',

    /** actions/setters */
    actions: {
        setIsExportLoading: (fileType: FileType, isExportLoading: boolean) =>
            fileType === FileType.PDF
                ? set({ isPDFExportLoading: isExportLoading })
                : set({ isWordExportLoading: isExportLoading }),
        setIsSupportingDocsLoading: (isSupportingDocsLoading: boolean) =>
            set({ isSupportingDocsLoading }),
        setExportUrl: (fileType: string, exportUrl: string) =>
            fileType === 'pdf'
                ? set({ pdfExportUrl: exportUrl })
                : set({ wordExportUrl: exportUrl }),
        setSupportingDocsUrl: (url: string) => set({ supportingDocsUrl: url }),
    },
}))

/** state Selectors */
export const useIsPDFExportLoading = () =>
    useActionBarStore((state) => state.isPDFExportLoading)
export const useIsWordExportLoading = () =>
    useActionBarStore((state) => state.isWordExportLoading)
export const useIsSupportingDocsLoading = () =>
    useActionBarStore((state) => state.isSupportingDocsLoading)
export const usePDFExportURL = () =>
    useActionBarStore((state) => state.pdfExportUrl)
export const useWordExportURL = () =>
    useActionBarStore((state) => state.wordExportUrl)
export const useSupportingDocsUrl = () =>
    useActionBarStore((state) => state.supportingDocsUrl)
/** actions/setters are stable and won't change between re-renders
 *
 * @example
 * ```typescript
 *     const { setSelectedProjectElementNode } = useActions()
 * ```
 */
export const useActionBarActions = () =>
    useActionBarStore((state) => state.actions)
